import { Box, Divider, Link, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { WHITESPACE_REGEX } from 'Regex';
import { ResultItem } from '../ResultItem';
import { RelatedActionItem } from '../RelatedActionItem';
import { IRelatedAction, IResult } from '../hooks/useSearchLogic';

interface SearchContentProps {
  value: string;
  results: IResult[];
  relatedActions: IRelatedAction[];
  isLoading: boolean;
  showNoResults: boolean;
  showResults: boolean;
  minSearchLength: number;
  onActivityClick: (action: IRelatedAction) => void;
}

export const SearchContent = ({
  value,
  results,
  relatedActions,
  isLoading,
  showNoResults,
  showResults,
  minSearchLength,
  onActivityClick,
}: SearchContentProps) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.ActivitiesLobby);
  const isDesktop = useIsDesktop();
  return (
    <>
      {isLoading && (
        <Typography variant='body3'>{dictionary.searching}</Typography>
      )}
      {showNoResults && (
        <Stack gap='8px'>
          <Typography variant='h3'>{dictionary.noResults.title}</Typography>
          <Typography
            variant='body3'
            lineHeight={'28px !important'}
            maxWidth={'330px'}
          >
            {dictionary.noResults.subtitle}
            <Link
              href={`https://shikum.mod.gov.il/Search?SearchTerm=${encodeURIComponent(
                value.replace(WHITESPACE_REGEX, '+')
              )}`}
              target='_blank'
              ml={'5px'}
            >
              {dictionary.noResults.websiteLabel}
            </Link>
          </Typography>
        </Stack>
      )}
      {showResults && (
        <Stack gap='16px'>
          {results.map((item, index: number) => (
            <Box key={index}>
              <ResultItem item={item} />
              {index < results.length - 1 && (
                <Divider sx={{ borderColor: '#E7E8ED', mt: '16px' }} />
              )}
            </Box>
          ))}
        </Stack>
      )}
      {showResults && relatedActions.length > 0 && (
        <Box sx={{ py: '8px' }}>
          <Divider sx={{ borderColor: '#E7E8ED' }} />
        </Box>
      )}
      {relatedActions.length > 0 && (
        <Stack gap='16px'>
          <Typography
            component={'h3'}
            variant='h6'
            mt={isDesktop ? undefined : '16px'}
          >
            {dictionary.relatedActions}
          </Typography>
          <Stack direction='row' gap='10px' flexWrap='wrap'>
            {relatedActions.map((action) => (
              <RelatedActionItem
                key={action.id}
                action={action}
                onClick={() => onActivityClick(action)}
              />
            ))}
          </Stack>
        </Stack>
      )}
      {!showResults &&
        !showNoResults &&
        !isLoading &&
        value.length < minSearchLength && (
          <Typography variant='body3' color='text.secondary'>
            {dictionary.searchHint}
          </Typography>
        )}
    </>
  );
};
